// extracted by mini-css-extract-plugin
export default {"otpInputGroup":"VerifyOTP_otpInputGroup__oiOmL","otpInput":"VerifyOTP_otpInput__yl-f-","error":"VerifyOTP_error__eLW9L"};